/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbUserGridDto } from './FcbUserGridDto';
import {
    FcbUserGridDtoFromJSON,
    FcbUserGridDtoFromJSONTyped,
    FcbUserGridDtoToJSON,
} from './FcbUserGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbUserGridDtoPaginatedResults
 */
export interface FcbUserGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbUserGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbUserGridDto>}
     * @memberof FcbUserGridDtoPaginatedResults
     */
    results?: Array<FcbUserGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbUserGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbUserGridDtoPaginatedResults interface.
 */
export function instanceOfFcbUserGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbUserGridDtoPaginatedResultsFromJSON(json: any): FcbUserGridDtoPaginatedResults {
    return FcbUserGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbUserGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbUserGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbUserGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbUserGridDtoPaginatedResultsToJSON(value?: FcbUserGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbUserGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

